import { setAuthToken, setAuthUser, setRefreshToken } from "../../../helpers/cookie-utils";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AutoLogin = () => {
  const [checkingAutoLogin, setCheckingAutoLogin] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
  (async () => {
    try {
      const query = new URLSearchParams(window.location.search);
      const encodedPayload = query.get("payload");

      if (!encodedPayload) {
        setCheckingAutoLogin(false);
        return;
      }

      // Decode payload safely
      let payload = null;
      try {
        const decodedString = decodeURIComponent(encodedPayload);
        payload = JSON.parse(decodedString);
      } catch (err) {
        console.error("Invalid payload:", err);
        setCheckingAutoLogin(false);
        return;
      }

      console.log("Decoded Payload:", payload);

      const reqBody = {
        domain: payload.domain ?? payload.company_domain ?? "",
        email: payload.email,
        password: payload.password,
      };
      console.log(reqBody, "reqBodyreqBody");

      const response = await axios.post(
        `https://wqjp2qmn-8000.inc1.devtunnels.ms/api/company/login/`,
        reqBody
      );

      // adjust according to your API shape
      if (response?.data?.status_code === 200) {
        const { access, refresh, user } = response.data.data;

        // Replace these with your real storage helpers
        setAuthToken(access);
        setRefreshToken(refresh);
        setAuthUser(user);

        console.log("Auto-login success, navigating...");
        navigate("/dashboard", { replace: true });
      } else {
        // optionally log response for debugging
        console.warn("Auto-login failed, server responded:", response?.data);
        throw new Error("Auto-login failed");
      }
    } catch (error) {
      console.error("Auto-login error:", error);
      // keep user on page and show manual login (or let parent handle)
    } finally {
      setCheckingAutoLogin(false);
    }
  })();
}, [navigate]);




  
  if (checkingAutoLogin) {
    return <div>Signing you in...</div>;
  }

  return <div>Auto-login failed. Please log in manually.</div>;
};

export default AutoLogin;
